import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100% !important;
  padding: 0px 0px 40px 0px;
  background-color: var(--white);
  z-index: 1;

  // Max Width Container
  div {
    max-width: 1270px;
    margin: 0 auto;
  }

  // Title
  div h3 {
    width: 100%;
    margin: 100px 0px 0px 0px;
    text-align: left;
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 2.25em;
    letter-spacing: -0.015em;
    color: var(--black);
  }

  // Text
  div p {
    width: 100%;
    max-width: 850px;
    margin: 40px 0px 0px 0px;
    text-align: left;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 30px;
    letter-spacing: -0.015em;
    color: var(--black);
  }

  // Seguro Images Container
  div div {
    width: 100%;
    margin: 90px 0px 0px 0px;
    display: flex;
    align-items: flex-end;
    align-content: center;
    justify-content: space-between;
  }

  // Seguro Logo
  div div a {
    transition: 0.2s all;
    filter: grayscale(100);
    height: auto;
  }

  div a img {
    object-fit: contain;
    height: auto;
  }

  // Seguro Logo Hover
  div div a:hover {
    cursor: pointer;
    filter: grayscale(0);
  }

  // Margin Page Contrataste
  .margin85 {
    margin: 85px 0px 0px 0px !important;
  }

  // 1710px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1710}) {
    // Title
    div h3 {
      font-size: 2em;
    }

    // Text
    div p {
      font-size: 0.96em;
    }
  }

  // 1600px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1600}) {
    // Max Width Container
    div {
      max-width: 1100px;
    }

    // Logos images width
    #seguroMotos {
      max-width: 152px;
    }

    #seguroMascotas {
      max-width: 231px;
    }

    #seguroHogar {
      max-width: 95px;
    }

    #seguroWeb {
      max-width: 177px;
    }

    #saludSegura {
      max-width: 177px;
    }
  }

  // 1440px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1440}) {
    // Title
    div h3 {
      font-size: 1.9em;
    }

    // Text
    div p {
      font-size: 0.938em;
    }
  }

  // 1366px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1366}) {
    // Max Width Container
    div {
      max-width: 1000px;
    }

    // Title
    div h3 {
      margin: 130px 0px 0px 0px;
    }
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    // Max Width Container
    div {
      max-width: 850px;
    }

    // Title
    div h3 {
      margin: 110px 0px 0px 0px;
    }

    // Seguro Images Container
    div div {
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: center;
      margin: 30px 0px 0px 0px;
    }

    // Seguro Logo
    div div a {
      width: 33.3%;
      margin: 40px 0px 0px 0px;
    }

    div div a img {
      display: block;
      margin: 0 auto;
    }

    // Logos images width
    #seguroMotos {
      max-width: 172px;
    }

    #seguroMascotas {
      max-width: 251px;
    }

    #seguroHogar {
      max-width: 115px;
    }

    #seguroWeb {
      max-width: 197px;
    }

    #saludSegura {
      max-width: 197px;
    }
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    // Max Width Container
    div {
      max-width: 700px;
    }
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    // Max Width Container
    div {
      max-width: 600px;
    }

    // Seguro Logo
    div div a {
      width: 50%;
      margin: 40px 0px 0px 0px;
    }
  }

  // 768px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet768}) {
    // Max Width Container
    div {
      max-width: 540px;
    }
  }

  // 670px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet670}) {
    // Max Width Container
    div {
      max-width: 480px;
    }

    // Title
    div h3 {
      margin: 80px 0px 0px 0px;
    }

    // Logos images width
    #seguroMotos {
      max-width: 150px;
    }

    #seguroMascotas {
      max-width: 230px;
    }

    #seguroHogar {
      max-width: 110px;
    }

    #seguroWeb {
      max-width: 187px;
    }

    #saludSegura {
      max-width: 187px;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    // Max Width Container
    div {
      max-width: 400px;
    }

    // Seguro Logo
    div div a {
      width: 100%;
      margin: 45px 0px 0px 0px;
    }

    // Logos images width
    #seguroMotos {
      max-width: 170px;
    }

    #seguroMascotas {
      max-width: 230px;
    }

    #seguroHogar {
      max-width: 125px;
    }

    #seguroWeb {
      max-width: 197px;
    }

    #saludSegura {
      max-width: 197px;
    }
  }

  // 450px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile450}) {
    // Max Width Container
    div {
      max-width: 88%;
      margin: 0 auto;
    }

    // Seguro Logo
    div div {
      width: 100%;
      margin: 0 auto !important;
    }
  }
`;

export default Container;
